import { groq } from 'next-sanity'

import { imageFragment } from './image'

export const caseEntryPreviewFragment = groq`
  "id": _id,
  title,
  "slug": slug.current,
  excerpt,
  coverImage {
    ${imageFragment}
  },
`
